import { render, staticRenderFns } from "./RootCauseReport.vue?vue&type=template&id=51982f49&scoped=true&"
import script from "./RootCauseReport.vue?vue&type=script&lang=js&"
export * from "./RootCauseReport.vue?vue&type=script&lang=js&"
import style0 from "./RootCauseReport.vue?vue&type=style&index=0&id=51982f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51982f49",
  null
  
)

export default component.exports